import BaseUrl from "./BaseUrl";

export default function loadScript(url: string, onLoad?: () => any) {
	const script = document.createElement("script");
	script.async = true;
	script.src = BaseUrl.apply(url);
	if (onLoad !== undefined) {
		script.onload = onLoad;
	}
	script.onerror = (url: string, err: string) => {
		console.error(`Failed to load script "${url}". Error: ${err}`);
	};
	document.body.appendChild(script);
}
